import AbstractListView from '@UI/Store/AbstractListView';
import type AuditEntryView from '@UI/Store/AuditTrail/Views/AuditEntryView';

/**
 * Immutable View: `readonly` properties, frozen at the end of the constructor.
 * Carries `totalRecords` alongside the page's `list`: the list is paginated server-side and the
 * screen runs under `cache: CACHE_DISABLED`, so `list.length` is only the current page — the
 * paginator needs `totalRecords` to know the real page count.
 */
class AuditEntriesListView extends AbstractListView<AuditEntryView> {
	readonly accountId: number;
	readonly totalRecords: number;

	constructor(list: readonly AuditEntryView[], accountId: number, totalRecords: number) {
		super(list, 'AuditEntriesListView');

		this.accountId = accountId;
		this.totalRecords = totalRecords;

		Object.freeze(this);
	}

	static replaceAll(
		list: readonly AuditEntryView[],
		accountId: number,
		totalRecords: number,
	): AuditEntriesListView {
		return new AuditEntriesListView(list, accountId, totalRecords);
	}
}

export default AuditEntriesListView;
